module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '跳转类型',
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: row.type.value,
              placeholder: '请选择',
            },
            on: {
              change: (type) => {
                row.type.value = type;
                s?.getTargetConfig(type, row);
              },
            },
          },
          row.type.options.map(({ label, value }) => {
            return h('el-option', { props: { label, value }}, null);
          })
        );

        return ele;
      },
    },
    {
      name: '跳转目标',
      width: '300px',
      format: (row) => {
        const h = s.$createElement;
        const brand_ele = h('div', {}, [
          h(
            'el-select',
            {
              class: 'mr-10',
              props: {
                size: 'mini',
                value: row.target.brand.value,
                placeholder: '请选择',
              },
              on: {
                change: (type) => {
                  row.target.brand.value = type;
                },
              },
            },
            row.target.brand.options.map(({ label, value, image_url }) => {
              return h('el-option', { class: 'flex', props: { label, value }}, [
                h(
                  'img',
                  {
                    class: 'mr-10',
                    style: 'padding: 2px 0;',
                    attrs: {
                      src: image_url,
                    },
                  },
                  null
                ),
                h(
                  'span',
                  {},
                  label
                ),
              ]);
            })
          ),
          h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
              },
              on: {
                click: () => {
                  s?.addBrand(row.advertiser_id);
                },
              },
            },
            '新增'
          ),
        ]);
        const wechat_channels_ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: row.target.wechat_channels.value,
              placeholder: '请选择',
            },
            on: {
              change: (type) => {
                row.target.wechat_channels.value = type;
              },
            },
          },
          row.target.wechat_channels.options.map(({ label, value }) => {
            return h('el-option', { props: { label, value }}, null);
          })
        );

        return row.type.value === 'brand' ? brand_ele : wechat_channels_ele;
      },
    },
  ];
};
